import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Pagination, Spin, Table, Select } from "antd";

import { handleError } from "../../modules/presence/sagas";
import { Filter } from "../../modules/presence/expenseReports/Accounting/components/Filter.component";
import { set } from "store";

const { Option } = Select;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

export const fetchRibsDisctinctIBANs = async (filters, token) => {
  return axios
    .post(`${baseapi}/ribs/distincts/IBAN`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};
export const fetchRibsDisctinctBICs = async (filters, token) => {
  return axios
    .post(`${baseapi}/ribs/distincts/BIC`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};
const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 10;

const Ribs = ({ available, token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedIBAN, setSelectedIBAN] = useState();
  const [selectedBIC, setSelectedBIC] = useState();

  const filters = {
    $or: [{ user_email: selectedUser }, { adresseMailPro: selectedUser }],
    IBAN: selectedIBAN,
    BIC: selectedBIC
  };
  const fetchRibs = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/ribs`,
        {
          match: filters,
          sort: { adresseMailPro: 1, user_email: 1 },
          page,
          pageSize: PAGE_SIZE
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data.docs);

      setTotal(result.data.total);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };
  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const resultSurvey = await axios.post(
        `${baseapi}/ribs/distincts/user_email`,
        {},
        {
          headers: {
            Authorization: token
          }
        }
      );
      const resultPortail = await axios.post(
        `${baseapi}/ribs/distincts/adresseMailPro`,
        {},
        {
          headers: {
            Authorization: token
          }
        }
      );
      setUsers([...new Set([...resultSurvey.data, ...resultPortail.data])].sort());
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };
  useEffect(() => {
    fetchUsers();
  }, []);
  useEffect(() => {
    fetchRibs();
  }, [page, selectedUser, selectedBIC, selectedIBAN]);
  const columns = [
    {
      title: "Utilisateur",
      dataIndex: "user_email",
      key: "user_email",
      render: (user_email, record) => {
        return <span>{user_email || record.adresseMailPro}</span>;
      }
    },

    {
      title: "IBAN",
      dataIndex: "IBAN",
      key: "IBAN"
    },
    {
      title: "BIC",
      dataIndex: "BIC",
      key: "BIC"
    },
    {
      title: "source",
      dataIndex: "source",
      key: "source"
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Liste des IBAN/BIC`}</div>
          <div style={{ width: "50%", display: "flex", flexDirection: "column" }}>
            <Select
              allowClear={true}
              showSearch
              placeholder={"Email"}
              style={{ width: 400, margin: 5 }}
              value={selectedUser}
              onChange={user => {
                setPage(1);
                setSelectedIBAN();
                setSelectedBIC();
                setSelectedUser(user);
              }}
            >
              {users.map(user => (
                <Option key={user} value={user}>
                  {user}
                </Option>
              ))}
            </Select>
            <Filter
              selectedItem={selectedIBAN}
              fetchDistinct={fetchRibsDisctinctIBANs}
              placeholder={"IBAN"}
              onChange={value => {
                setPage(1);
                setSelectedBIC();
                setSelectedUser();
                setSelectedIBAN(value);
              }}
              token={token}
              filters={filters}
              width={400}
            />
            <Filter
              selectedItem={selectedBIC}
              fetchDistinct={fetchRibsDisctinctBICs}
              placeholder={"BIC"}
              onChange={value => {
                setPage(1);
                setSelectedIBAN();
                setSelectedUser();
                setSelectedBIC(value);
              }}
              token={token}
              filters={filters}
              width={400}
            />
          </div>
        </div>
        <div style={{ width: "30%" }} />
      </HeaderContainer>
      {available ? (
        <React.Fragment>
          {isLoading ? (
            <Spin />
          ) : (
            <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
          )}
          <Pagination defaultCurrent={1} total={total} onChange={setPage} />
        </React.Fragment>
      ) : (
        <div style={{ fontSize: 60 }}>Ecran réservé à la comptable</div>
      )}
    </Container>
  );
};

export default Ribs;



// WEBPACK FOOTER //
// src/pages/poc_rib/Ribs.js